import { useMutation } from '@tanstack/react-query'
import { useApiClient } from 'hooks/useApiClient'
import { type FileRequest } from 'types/fileUpload'

interface UsePostImportPatronsProps {
  id: number
}

export const usePostImportPatrons = ({ id }: UsePostImportPatronsProps) => {
  const postAPIClient = useApiClient()

  return useMutation({
    mutationFn: async (importPatrons: FileRequest) => {
      const body = new FormData()
      body.set('FileUpload', importPatrons.File)
      body.set('FileUploadName', importPatrons.FileName)
      body.set('FileUploadType', importPatrons.FileType)

      const { data, error } = await postAPIClient.post(
        '/admin/campaigns/{id}/importpatrons',
        {
          params: { path: { id } },
          body: {},
          bodySerializer: () => body,
          parseAs: 'text',
        }
      )
      return { data, error }
    },
  })
}
